import { Injectable } from '@angular/core';
import { NavController, PopoverController } from 'ionic-angular';
import { Observable } from 'rxjs/Observable';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { Subject } from 'rxjs/Subject';
import { BaseController } from '../../../core/controllers/base.controller';
import { VasAppFacade } from '../../services/vas-app-facade.service';
import { OnlineStatusModel } from './online-status.model';

@Injectable()
export class OnlineStatusController extends BaseController {

    protected _model$ = new Subject<OnlineStatusModel>();
    protected _model: OnlineStatusModel;

    constructor(
        protected appFacade: VasAppFacade,
        protected popoverCtrl: PopoverController,
        protected navController: NavController
    ) {
        super();
    }

    ngOnInit(): void {

        combineLatest(
            this.appFacade.objects.account.store.getActive(),
            this.appFacade.session.getSession(),
            this.appFacade.syncDown.busy$,
            this.appFacade.syncUp.busy$,
            this.appFacade.objects.job.store.getUiLoading()
        )
            .takeUntil(this.ngUnsubscribe)
            .map(([
                      account,
                      session,
                      syncDownBusy,
                      syncUpBusy,
                      jobsBusy
                  ]) => {
                return OnlineStatusModel.getInstance({
                    accountId: (account || {} as any).id,
                    session,
                    busy: syncDownBusy || syncUpBusy || jobsBusy
                });
            })
            .subscribe(model => this.model = model);
    }

    set model(model: OnlineStatusModel) {
        this._model = model;
        this._model$.next(model);
    }

    get model(): OnlineStatusModel {
        return this._model;
    }

    get model$(): Observable<OnlineStatusModel> {
        return this._model$;
    }

    showStatusOptions($event): void {
        const p = this.popoverCtrl.create('OnlineStatusModalComponent');

        p.present({
            ev: $event
        });
    }

    openSignInPage(): void {
        this.navController.setRoot('LoginPage');
    }

    refresh(): void {
        this.appFacade.syncDown.syncRefresh(this.model.accountId)
            .catch(error => this.appFacade.toast.toastDanger(error));
    }

    syncDownFull(): void {
        this.appFacade.syncDown.syncFull(this.model.accountId)
            .catch(error => this.appFacade.toast.toastDanger(error));
    }

    syncUp(): void {
        this.appFacade.syncUp.sync()
            .catch(error => this.appFacade.toast.toastDanger(error));
    }
}



// WEBPACK FOOTER //
// ./src/vas/modules-other/online-status/online-status.controller.ts